import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[960px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          读者好评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          来自真实读者的评价，一起加入包子漫画大家庭
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {commentsData.map((c) => (
            <div
              key={c.name}
              className="p-5 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={c.avatar}
                    alt={c.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-800">{c.name}</div>
                  <div className="text-xs text-foreground-400">{c.date}</div>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: c.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}